import { useMemo } from 'react';
import { Field, FieldTypes } from '@common-fe/common-fe';
import * as yup from 'yup';

import { REQUIRED_TEXT } from '@/common/constants';
import useContactStore, { ContactPayload } from '@/modules/ExpressSetup/AddEditContactForm/stores/useContact.store';
import useFieldsWithDefaultValues from '@/utils/hooks/useFieldsWithDefaultValues';

export const ADMIN_1_ID = '4';
export const NO_ACCESS_ID = '11';

export default (isMainContactMode?: boolean, summaryMode?: boolean, currentContact?: ContactPayload) => {
  const defaultFields = useContactStore((state) => state.sourceState);
  const fields = useMemo((): Field[] => [
    {
      name: 'role',
      type: FieldTypes.Radio,
      label: 'Role',
      showRequireIcon: true,
      inputStyle: { alignItems: 'center' },
      disabled: isMainContactMode,
      options: [
        {
          label: 'Full Access!',
          value: ADMIN_1_ID, // Roles.admin1 = 4
          hintText: 'Contact will have full access to all tools on the employer dashboard.',
        },
        {
          label: 'No Access',
          value: NO_ACCESS_ID ,// Roles.noAccess = 11
          hintText: 'Contact will not be grated access but will receive notifications and alerts regarding activity for the plan.',
        },
      ],
      value: isMainContactMode ? ADMIN_1_ID : '',
      validator: yup.string().required(REQUIRED_TEXT),
    },
  ], [isMainContactMode]);

  const formatedFields = useFieldsWithDefaultValues(fields, summaryMode ? currentContact : defaultFields);
  return formatedFields;
};
